import { safeDefine } from "../../registration/safe-define.js";
import { MuxDataExtension } from "../../extensions/mux-data/extension.js";
//#region src/define/extensions/mux-data.ts
safeDefine(MuxDataExtension);
//#endregion
export { MuxDataExtension };

//# sourceMappingURL=mux-data.js.map